import { useAtomValue } from "jotai";
import {
  nicknameAtom,
  softSkillsAtom,
  toolsExperienceAtom,
  projectTypeAtom,
  offeredGratificationAtom,
  requiredAreaOfExpertiseAtom,
  toolsExperienceOptionViewsAtom,
  forGratificationAtom,
  projectDeadlineAtom,
  productTypeAtom
} from "../pages/Teammate/atoms/AddTeammateAtomPage1";

import {
  hardSkillsAtom,
  offeredWorkingTypeActiveOptionsAtom,
  descriptionAtom
} from "../pages/Teammate/atoms/AddTeammateAtomPage2";

import {
  usedLanguagesAtom,
  bizOrTechRoleAtomLeftValue,
  bizOrTechRoleAtomRightValue,
  requiredAvailabilityAtomStartValue,
  requiredAvailabilityAtomEndValue,
  requiredAvailabilityAtomOption,
  locationsAtom,
} from "../pages/Teammate/atoms/AddTeammateAtomPage3";

interface reqBody {
  softSkills?: string[];
  areaOfExpertise?: string[];
  toolsExperience?: any;
  hardSkills?: string[];
  offeredGratification?: string[];
  forGratification?: string[];
  nickname?: string;
  projectType?: string[];
  bizRole?: number;
  techRole?: number;
  availabilityFrom?: number;
  availabilityTo?: number;
  availabilityType?: string;
  workingTypeOffice?: boolean;
  workingTypeRemote?: boolean;
  usedLanguages?: string[];
  description?: string;
  locations?: string[];
  deadline?: Date;
  productType: string[];
}

const useDataFromAddTeammate = (): reqBody => {
  const nickname = useAtomValue(nicknameAtom);
  const softSkills = useAtomValue(softSkillsAtom);
  const toolsExperience = useAtomValue(toolsExperienceAtom);
  const projectType = useAtomValue(projectTypeAtom);
  const offeredGratification = useAtomValue(offeredGratificationAtom);
  const forGratification = useAtomValue(forGratificationAtom);
  const requiredAreaOfExpertise = useAtomValue(requiredAreaOfExpertiseAtom);
  const toolsExperienceOptionViews = useAtomValue(
    toolsExperienceOptionViewsAtom,
  ); // months!
  const hardSkills = useAtomValue(hardSkillsAtom);
  const offeredWorkingTypeActiveOptions = useAtomValue(
    offeredWorkingTypeActiveOptionsAtom,
  );
  const usedLanguages = useAtomValue(usedLanguagesAtom);
  const bizOrTechRoleLeftValue = useAtomValue(bizOrTechRoleAtomLeftValue);
  const bizOrTechRoleRightValue = useAtomValue(bizOrTechRoleAtomRightValue);
  const requiredAvailabilityStartValue = useAtomValue(
    requiredAvailabilityAtomStartValue,
  );
  const requiredAvailabilityEndValue = useAtomValue(
    requiredAvailabilityAtomEndValue,
  );
  const requiredAvailabilityOption = useAtomValue(
    requiredAvailabilityAtomOption,
  );
  const description = useAtomValue(descriptionAtom);
  const locations = useAtomValue(locationsAtom);
  const projectDeadline = useAtomValue(projectDeadlineAtom);
  const productType = useAtomValue(productTypeAtom);

  let body: reqBody = {};
  body.nickname = nickname;
  body.softSkills = softSkills;
  body.toolsExperience = [];
  body.projectType = projectType;
  body.offeredGratification = offeredGratification;
  body.forGratification = forGratification;
  body.areaOfExpertise = requiredAreaOfExpertise;
  body.hardSkills = hardSkills;
  body.workingTypeRemote = offeredWorkingTypeActiveOptions[0];
  body.workingTypeOffice = offeredWorkingTypeActiveOptions[1];
  body.usedLanguages = usedLanguages;
  body.bizRole =
    bizOrTechRoleLeftValue == "" ? 50 : parseInt(bizOrTechRoleLeftValue);
  body.techRole =
    bizOrTechRoleRightValue == "" ? 50 : parseInt(bizOrTechRoleRightValue);
  body.availability = requiredAvailabilityStartValue;
  body.locations = locations;
  body.description = description;
  body.deadline = projectDeadline;
  body.productType = productType;

  const keys = Object.keys(body);
  for (const key of keys) {
    if (!body[key as keyof reqBody]) {
      delete body[key as keyof reqBody];
    }
  } // is array empty we can do sth like that

  for (const tool of toolsExperience) {
    body.toolsExperience.push({
      tool: tool,
      mep: toolsExperienceOptionViews[tool],
    });
  }

  return body;
};

export { useDataFromAddTeammate };
